/* eslint-disable */

const excludedPathPrefixes = [
    '/search',
    '/event/',
    '/orga/',
]

export default function matomoInit() {
    if (document.cookie.indexOf('MATOMO_WITH_CONSENT') < 0
    && document.cookie.indexOf('MATOMO_EXEMPTED_CONSENT') < 0) {
        return;
    }

    if (excludedPathPrefixes.some(p => (document.location.pathname.indexOf(p) === 0))) {
        return;
    }

    var _paq = window._paq = window._paq || [];
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);

    // User accepted Matomo advanced tracking
    if (document.cookie.indexOf('MATOMO_WITH_CONSENT')) {
        _paq.push(['setCookieConsentGiven']);
        // Enable Cross-domain tracking
        // Doc: https://matomo.org/faq/how-to/faq_23654/
        _paq.push(["setDomains", ["*.yurplan.com"]]);
        _paq.push(["enableCrossDomainLinking"]);
    } else {
        _paq.push(['setConsentGiven']);
        _paq.push(['HeatmapSessionRecording::disable']);
    }

    // Load Matomo tracking script
    (function() {
        var u=`${env.MATOMO_URL}/`;
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', env.MATOMO_SITE_ID]);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
}
